import { ONBOARDING_AB_TEST_VERSIONS } from 'enums/configuration';

export function handleBucketLogic(targetPercentage, bucketIdentifier) {
  return bucketIdentifier >= targetPercentage
    ? ONBOARDING_AB_TEST_VERSIONS.form
    : ONBOARDING_AB_TEST_VERSIONS.interactive;
}

export function convertCohortIdToInteger(cohortId) {
  // defaults to normal case which is no action/ proceed as normal
  if (!cohortId) {
    return 0;
  }

  let convertedId = 0;

  for (let i = 0; i < cohortId.length; i++) {
    convertedId += cohortId.charCodeAt(i);
  }

  return convertedId % 100;
}

// Check for alternate bucket. Differentiating between A/B gives more description in analysis vs a bool
export function isAlternateBucket(bucket) {
  return bucket === ONBOARDING_AB_TEST_VERSIONS.interactive;
}
